var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pda-menu"},_vm._l((_vm.menuData),function(item,i){return _c('div',{key:i,staticClass:"menu-item",on:{"click":function($event){return _vm.go(item.href)}}},[_c('img',{staticClass:"icon",attrs:{"src":`${_vm.baseUrl}/static/images/pda/${item.icon}.png`,"alt":"png"}}),_c('p',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }